var hourlyLaborData = [
    {
        'RPT_HOURLY_LABOR_ID': 17935265.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 10.0,
        'HOUR_START_STR': '9:00a',
        'HOUR_END_STR': '9:59a',
        'HOUR_STR': '9:00a - 9:59a',
        'LABOR_HOURS': 1.38,
        'LABOR_AMT': 1.11,
        'LABOR_PCT': 1.06,
        'SALES_AMT': 0.0,
        'SALES_AMT_PER_LABOR_AMT': 0.0,
        'SALES_AMT_PER_LABOR_HOURS': 0.0,
        'LABOR_COST_PCT': 0.0,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935266.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 11.0,
        'HOUR_START_STR': '10:00a',
        'HOUR_END_STR': '10:59a',
        'HOUR_STR': '10:00a - 10:59a',
        'LABOR_HOURS': 4.25,
        'LABOR_AMT': 4.47,
        'LABOR_PCT': 4.26,
        'SALES_AMT': 0.0,
        'SALES_AMT_PER_LABOR_AMT': 0.0,
        'SALES_AMT_PER_LABOR_HOURS': 0.0,
        'LABOR_COST_PCT': 0.0,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935267.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 12.0,
        'HOUR_START_STR': '11:00a',
        'HOUR_END_STR': '11:59a',
        'HOUR_STR': '11:00a - 11:59a',
        'LABOR_HOURS': 6.77,
        'LABOR_AMT': 7.89,
        'LABOR_PCT': 7.51,
        'SALES_AMT': 13.25,
        'SALES_AMT_PER_LABOR_AMT': 1.68,
        'SALES_AMT_PER_LABOR_HOURS': 1.96,
        'LABOR_COST_PCT': 59.55,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935268.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 13.0,
        'HOUR_START_STR': '12:00p',
        'HOUR_END_STR': '12:59p',
        'HOUR_STR': '12:00p - 12:59p',
        'LABOR_HOURS': 8.0,
        'LABOR_AMT': 7.89,
        'LABOR_PCT': 7.51,
        'SALES_AMT': 241.79,
        'SALES_AMT_PER_LABOR_AMT': 30.65,
        'SALES_AMT_PER_LABOR_HOURS': 30.22,
        'LABOR_COST_PCT': 3.26,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935269.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 14.0,
        'HOUR_START_STR': '1:00p',
        'HOUR_END_STR': '1:59p',
        'HOUR_STR': '1:00p - 1:59p',
        'LABOR_HOURS': 8.0,
        'LABOR_AMT': 7.89,
        'LABOR_PCT': 7.51,
        'SALES_AMT': 572.56,
        'SALES_AMT_PER_LABOR_AMT': 72.57,
        'SALES_AMT_PER_LABOR_HOURS': 71.57,
        'LABOR_COST_PCT': 1.38,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935270.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 15.0,
        'HOUR_START_STR': '2:00p',
        'HOUR_END_STR': '2:59p',
        'HOUR_STR': '2:00p - 2:59p',
        'LABOR_HOURS': 6.68,
        'LABOR_AMT': 4.89,
        'LABOR_PCT': 4.65,
        'SALES_AMT': 556.84,
        'SALES_AMT_PER_LABOR_AMT': 113.87,
        'SALES_AMT_PER_LABOR_HOURS': 83.36,
        'LABOR_COST_PCT': 0.88,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935271.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 16.0,
        'HOUR_START_STR': '3:00p',
        'HOUR_END_STR': '3:59p',
        'HOUR_STR': '3:00p - 3:59p',
        'LABOR_HOURS': 5.0,
        'LABOR_AMT': 2.89,
        'LABOR_PCT': 2.75,
        'SALES_AMT': 295.60,
        'SALES_AMT_PER_LABOR_AMT': 102.28,
        'SALES_AMT_PER_LABOR_HOURS': 59.12,
        'LABOR_COST_PCT': 0.98,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935272.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 17.0,
        'HOUR_START_STR': '4:00p',
        'HOUR_END_STR': '4:59p',
        'HOUR_STR': '4:00p - 4:59p',
        'LABOR_HOURS': 6.62,
        'LABOR_AMT': 6.60,
        'LABOR_PCT': 6.28,
        'SALES_AMT': 315.32,
        'SALES_AMT_PER_LABOR_AMT': 47.78,
        'SALES_AMT_PER_LABOR_HOURS': 47.63,
        'LABOR_COST_PCT': 2.09,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935273.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 18.0,
        'HOUR_START_STR': '5:00p',
        'HOUR_END_STR': '5:59p',
        'HOUR_STR': '5:00p - 5:59p',
        'LABOR_HOURS': 13.17,
        'LABOR_AMT': 9.54,
        'LABOR_PCT': 9.08,
        'SALES_AMT': 594.38,
        'SALES_AMT_PER_LABOR_AMT': 62.30,
        'SALES_AMT_PER_LABOR_HOURS': 45.13,
        'LABOR_COST_PCT': 1.61,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935274.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 19.0,
        'HOUR_START_STR': '6:00p',
        'HOUR_END_STR': '6:59p',
        'HOUR_STR': '6:00p - 6:59p',
        'LABOR_HOURS': 12.87,
        'LABOR_AMT': 9.92,
        'LABOR_PCT': 9.44,
        'SALES_AMT': 1269.26,
        'SALES_AMT_PER_LABOR_AMT': 127.95,
        'SALES_AMT_PER_LABOR_HOURS': 98.62,
        'LABOR_COST_PCT': 0.78,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935275.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 20.0,
        'HOUR_START_STR': '7:00p',
        'HOUR_END_STR': '7:59p',
        'HOUR_STR': '7:00p - 7:59p',
        'LABOR_HOURS': 12.0,
        'LABOR_AMT': 8.67,
        'LABOR_PCT': 8.25,
        'SALES_AMT': 1665.63,
        'SALES_AMT_PER_LABOR_AMT': 192.11,
        'SALES_AMT_PER_LABOR_HOURS': 138.80,
        'LABOR_COST_PCT': 0.52,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935276.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 21.0,
        'HOUR_START_STR': '8:00p',
        'HOUR_END_STR': '8:59p',
        'HOUR_STR': '8:00p - 8:59p',
        'LABOR_HOURS': 9.72,
        'LABOR_AMT': 8.67,
        'LABOR_PCT': 8.25,
        'SALES_AMT': 1164.61,
        'SALES_AMT_PER_LABOR_AMT': 134.33,
        'SALES_AMT_PER_LABOR_HOURS': 119.82,
        'LABOR_COST_PCT': 0.74,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935277.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 22.0,
        'HOUR_START_STR': '9:00p',
        'HOUR_END_STR': '9:59p',
        'HOUR_STR': '9:00p - 9:59p',
        'LABOR_HOURS': 6.02,
        'LABOR_AMT': 8.67,
        'LABOR_PCT': 8.25,
        'SALES_AMT': 246.25,
        'SALES_AMT_PER_LABOR_AMT': 28.40,
        'SALES_AMT_PER_LABOR_HOURS': 40.91,
        'LABOR_COST_PCT': 3.52,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935278.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 23.0,
        'HOUR_START_STR': '10:00p',
        'HOUR_END_STR': '10:59p',
        'HOUR_STR': '10:00p - 10:59p',
        'LABOR_HOURS': 4.05,
        'LABOR_AMT': 5.54,
        'LABOR_PCT': 5.27,
        'SALES_AMT': 476.06,
        'SALES_AMT_PER_LABOR_AMT': 85.93,
        'SALES_AMT_PER_LABOR_HOURS': 117.55,
        'LABOR_COST_PCT': 1.16,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935279.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 24.0,
        'HOUR_START_STR': '11:00p',
        'HOUR_END_STR': '11:59p',
        'HOUR_STR': '11:00p - 11:59p',
        'LABOR_HOURS': 2.48,
        'LABOR_AMT': 2.89,
        'LABOR_PCT': 2.75,
        'SALES_AMT': 367.55,
        'SALES_AMT_PER_LABOR_AMT': 127.18,
        'SALES_AMT_PER_LABOR_HOURS': 148.21,
        'LABOR_COST_PCT': 0.79,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935280.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 25.0,
        'HOUR_START_STR': '12:00a',
        'HOUR_END_STR': '12:59a',
        'HOUR_STR': '12:00a - 12:59a',
        'LABOR_HOURS': 2.10,
        'LABOR_AMT': 5.78,
        'LABOR_PCT': 5.50,
        'SALES_AMT': 285.15,
        'SALES_AMT_PER_LABOR_AMT': 49.33,
        'SALES_AMT_PER_LABOR_HOURS': 135.79,
        'LABOR_COST_PCT': 2.03,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    },
    {
        'RPT_HOURLY_LABOR_ID': 17935281.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1727725.0,
        'HOUR_NUM': 26.0,
        'HOUR_START_STR': '1:00a',
        'HOUR_END_STR': '1:59a',
        'HOUR_STR': '1:00a - 1:59a',
        'LABOR_HOURS': 0.60,
        'LABOR_AMT': 1.74,
        'LABOR_PCT': 1.66,
        'SALES_AMT': 0.0,
        'SALES_AMT_PER_LABOR_AMT': 0.0,
        'SALES_AMT_PER_LABOR_HOURS': 0.0,
        'LABOR_COST_PCT': 0.0,
        'LOAD_TIME': '2020-04-13T19:25:00',
        'BUSINESS_DATE': '2020-04-13T00:00:00'
    }
]

export default hourlyLaborData